export enum ReportAction {
    DAILY_EXPORT = 'DAILY_EXPORT',
    USER_ACTION = 'USER_ACTION'
}
